export const ProductInstanceStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};
